__turbopack_context__.v({
  "fade-in": "PromoItem-module-scss-module__KPNOsa__fade-in",
  "modalImage": "PromoItem-module-scss-module__KPNOsa__modalImage",
  "no-transform": "PromoItem-module-scss-module__KPNOsa__no-transform",
  "rotate": "PromoItem-module-scss-module__KPNOsa__rotate",
});
